<template>
  <div class="full-height">
    <q-card class="full-height full-width">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">
          {{ outcomeFormData ? outcomeFormData.name : Outcome }}
        </div>
        <q-space></q-space>
        <q-btn
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="saveOutcome"
        >
          Save & Close
        </q-btn>
        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <q-tabs v-model="tab" align="left">
          <q-tab v-for="(tabItem, i) in tabsList" :key="i" :name="tabItem.name">
            <div style="display: inline">
              <span class="tabTitle">{{ tabItem.label }} </span>
              <q-icon
                name="mdi-alert-circle"
                color="red"
                v-if="tabItem.isError"
              >
              </q-icon>
            </div>
          </q-tab>
        </q-tabs>

        <q-tab-panels v-model="tab" animated keep-alive ref="tabs">
          <!--GENERAL-->
          <q-tab-panel name="general">
            <div class="row q-mb-sm items-center">
              <div class="col-12">
                <div class="row justify-center">
                  <div
                    style="width: 300px; height: 120px; border-radius: 10px"
                    class="bg-accent row justify-center items-center"
                  >
                    <q-img
                      class="q-mb-sm q-mx-auto"
                      style="width: 80px; height: 80px"
                      :src="returnOutcomeImage(this.data)"
                    >
                    </q-img>
                    <q-img
                      class="q-mb-sm q-mx-auto"
                      style="width: 80px; height: 80px"
                      :src="getWhiteOutcomeImage(this.data)"
                    >
                    </q-img>
                  </div>
                </div>
              </div>
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="col-2">
                    <div class="title q-my-none">Info</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row q-my-sm">
              <div
                v-if="
                  (changeImage || !outcomeFormData.imageUrl) &&
                  outcomeFormData.id
                "
              >
                <div style="width: 200px">
                  <croppa
                    ref="imgCroppa"
                    :height="200"
                    :width="300"
                    v-model="myCroppa"
                    remove-button-color="#68c6d2"
                    :show-loading="true"
                    :loading-size="50"
                    crossOrigin="anonymous"
                    :quality="2"
                    :prevent-white-space="false"
                  ></croppa>
                </div>
                <span class="text-caption">
                  Recommended .jpg/.jpeg files and ideally 500Kb
                </span>
              </div>
              <div v-else style="width: 300px">
                <q-img
                  :src="outcomeFormData.imageUrl"
                  style="width: 300px; height: 200px"
                  v-if="outcomeFormData.id"
                >
                </q-img>
                <q-btn
                  class="full-width"
                  color="primary"
                  label="Change"
                  @click="changeImage = true"
                  v-if="outcomeFormData.id"
                >
                </q-btn>
                <span class="text-caption"
                  >Recommended .jpg/.jpeg files and ideally 500Kb
                </span>
              </div>
            </div>
            <q-form ref="form">
              <div class="row q-col-gutter-y-lg q-col-gutter-x-md">
                <div class="col-2">
                  <q-input
                    label="Name"
                    v-model="outcomeFormData.name"
                    :rules="[(v) => !!v || 'Name is Required']"
                    readonly
                  >
                  </q-input>
                </div>
                <div class="col-2">
                  <q-input
                    label="Umbrella"
                    v-model="outcomeFormData.umbrella"
                    :rules="[(v) => !!v || 'Name is Required']"
                    readonly
                  >
                  </q-input>
                </div>
                <div class="col-3">
                  <q-input
                    label="Display Name"
                    v-model="outcomeFormData.label"
                    :rules="[(v) => !!v || 'Name is Required']"
                    hint="This is the name displayed to the Customers"
                  >
                  </q-input>
                </div>
                <div class="col-3">
                  <q-input
                    label="Short Display Name"
                    v-model="outcomeFormData.shortLabel"
                    :rules="[(v) => !!v || 'Short Label is Required']"
                    hint="This is the short name displayed to the Customers"
                  >
                  </q-input>
                </div>
                <div class="col-2">
                  <q-select
                    v-model="outcomeFormData.status"
                    :options="statusOptions"
                    label="Status"
                    :rules="[(v) => !!v || 'Status is Required']"
                  ></q-select>
                </div>
                <div class="col-4">
                  <q-input
                    label="Positive Data Label"
                    v-model="outcomeFormData.positiveLabel"
                    hint="This is the label used for Positive data (e.g. Renewable/Diverted)"
                  >
                  </q-input>
                </div>
                <div class="col-4">
                  <q-input
                    label="Negative Data Label"
                    v-model="outcomeFormData.negativeLabel"
                    hint="This is the label used for Negative data (e.g. Non-Renweable/Landfill)"
                  >
                  </q-input>
                </div>
                <div class="col-4">
                  <q-checkbox
                    v-model="outcomeFormData.usesFactor"
                    label="Uses Factor"
                    :true-value="1"
                    :false-value="0"
                  ></q-checkbox>
                </div>
                <div class="col-6" v-if="outcomeFormData.usesFactor">
                  <q-input
                    label="Factor Multiplier"
                    v-model="outcomeFormData.factorMultiplier"
                    hint="This is the multiplier for the factors used in reporting, e.g. convert kgCO2-e -> tCO2-e = 0.001"
                    type="number"
                  >
                  </q-input>
                </div>
                <div class="col-6" v-if="outcomeFormData.usesFactor">
                  <q-input
                    label="Factor Multiplied Unit"
                    v-model="outcomeFormData.factorUnitDisplay"
                    hint="This is the label/unit displayed anywhere that the Factor multiplier is used, e.g. tCO2-e"
                  >
                  </q-input>
                </div>
                <div class="col-4">
                  <q-input
                    label="Primary Color"
                    v-model="outcomeFormData.primaryColor"
                  >
                    <template v-slot:append>
                      <q-icon
                        name="mdi-square-rounded"
                        :style="`border: 1px solid black; border-radius: 7px;color: ${stringToHexCode(
                          outcomeFormData.primaryColor
                        )}`"
                      />
                    </template>
                    <template>
                      <q-popup-proxy
                        ref="primaryColorProxy"
                        transition-show="scale"
                        transition-hide="scale"
                        :breakpoint="0"
                        v-model="primaryColorDialog"
                      >
                        <div>
                          <q-color
                            v-model="outcomeFormData.primaryColor"
                            no-footer
                            flat
                            no-header
                            no-header-tabs
                            style="width: 250px"
                          />
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="close"
                              color="accent"
                              flat
                            />
                          </div>
                        </div>
                      </q-popup-proxy>
                    </template>
                  </q-input>
                </div>
                <div class="col-4">
                  <q-input
                    label="Secondary Color"
                    v-model="outcomeFormData.secondaryColor"
                  >
                    <template v-slot:append>
                      <q-icon
                        name="mdi-square-rounded"
                        :style="`border: 1px solid black; border-radius: 7px;color: ${stringToHexCode(
                          outcomeFormData.secondaryColor
                        )}`"
                      />
                    </template>
                    <template>
                      <q-popup-proxy
                        ref="secondaryColorProxy"
                        transition-show="scale"
                        transition-hide="scale"
                        :breakpoint="0"
                        v-model="secondaryColorDialog"
                      >
                        <div>
                          <q-color
                            v-model="outcomeFormData.secondaryColor"
                            no-footer
                            flat
                            no-header
                            no-header-tabs
                            style="width: 250px"
                          />
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="close"
                              color="accent"
                              flat
                            />
                          </div>
                        </div>
                      </q-popup-proxy>
                    </template>
                  </q-input>
                </div>
                <div class="col-4">
                  <q-input
                    label="Tertiary Color"
                    v-model="outcomeFormData.tertiaryColor"
                  >
                    <template v-slot:append>
                      <q-icon
                        name="mdi-square-rounded"
                        :style="`border: 1px solid black; border-radius: 7px;color: ${stringToHexCode(
                          outcomeFormData.tertiaryColor
                        )}`"
                      />
                    </template>
                    <template>
                      <q-popup-proxy
                        ref="tertiaryColorProxy"
                        transition-show="scale"
                        transition-hide="scale"
                        :breakpoint="0"
                        v-model="tertiaryColorDialog"
                      >
                        <div>
                          <q-color
                            v-model="outcomeFormData.tertiaryColor"
                            no-footer
                            flat
                            no-header
                            no-header-tabs
                            style="width: 250px"
                          />
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="close"
                              color="accent"
                              flat
                            />
                          </div>
                        </div>
                      </q-popup-proxy>
                    </template>
                  </q-input>
                </div>

                <div class="col-12">
                  <q-input
                    label="Admin Notes"
                    v-model="outcomeFormData.adminNotes"
                    type="textarea"
                    class="q-mb-lg"
                  >
                  </q-input>
                </div>
                <div class="col-12">
                  <p class="text-bold">
                    Story Board - What is section (Side Panel)
                  </p>
                  <q-editor
                    v-model="outcomeFormData.storyBoardWhatIs"
                    :dense="$q.screen.lt.md"
                    :toolbar="[
                      [
                        {
                          label: $q.lang.editor.align,
                          icon: $q.iconSet.editor.align,
                          fixedLabel: true,
                          list: 'only-icons',
                          options: ['left', 'center', 'right', 'justify'],
                        },
                        {
                          label: $q.lang.editor.align,
                          icon: $q.iconSet.editor.align,
                          fixedLabel: true,
                          options: ['left', 'center', 'right', 'justify'],
                        },
                      ],
                      [
                        'bold',
                        'italic',
                        'strike',
                        'underline',
                        'subscript',
                        'superscript',
                      ],
                      ['token', 'hr', 'link', 'custom_btn'],
                      ['print', 'fullscreen'],
                      [
                        {
                          label: $q.lang.editor.formatting,
                          icon: $q.iconSet.editor.formatting,
                          list: 'no-icons',
                          options: [
                            'p',
                            'h1',
                            'h2',
                            'h3',
                            'h4',
                            'h5',
                            'h6',
                            'code',
                          ],
                        },
                        {
                          label: $q.lang.editor.fontSize,
                          icon: $q.iconSet.editor.fontSize,
                          fixedLabel: true,
                          fixedIcon: true,
                          list: 'no-icons',
                          options: [
                            'size-1',
                            'size-2',
                            'size-3',
                            'size-4',
                            'size-5',
                            'size-6',
                            'size-7',
                          ],
                        },
                        {
                          label: $q.lang.editor.defaultFont,
                          icon: $q.iconSet.editor.font,
                          fixedIcon: true,
                          list: 'no-icons',
                          options: [
                            'default_font',
                            'arial',
                            'arial_black',
                            'comic_sans',
                            'courier_new',
                            'impact',
                            'lucida_grande',
                            'times_new_roman',
                            'verdana',
                          ],
                        },
                        'removeFormat',
                      ],
                      ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                      ['undo', 'redo'],
                      ['viewsource'],
                    ]"
                    :fonts="{
                      arial: 'Arial',
                      arial_black: 'Arial Black',
                      comic_sans: 'Comic Sans MS',
                      courier_new: 'Courier New',
                      impact: 'Impact',
                      lucida_grande: 'Lucida Grande',
                      times_new_roman: 'Times New Roman',
                      verdana: 'Verdana',
                    }"
                  />
                </div>
              </div>
            </q-form>
          </q-tab-panel>
          <!--SOURCES-->
          <q-tab-panel name="sources">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Sources</div>
                  <div style="width: 200px">
                    <q-form ref="sourceForm">
                      <q-select
                        :options="filteredSourcesList"
                        v-model="selectedSource"
                        label="Source"
                        map-options
                        emit-value
                        option-value="id"
                        option-label="name"
                        dense
                        use-input
                        @filter="filterSource"
                      >
                        <template v-slot:no-option>
                          <q-item>
                            <q-item-section class="text-grey">
                              No results
                            </q-item-section>
                          </q-item>
                        </template>
                      </q-select>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!selectedSource"
                      color="primary"
                      @click="addSource"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchTextSources"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <data-table
                  style="height: calc(100vh - 260px)"
                  flat
                  :columns="columns"
                  :data="sourcesOutcomesList"
                  :filter="searchTextSources"
                  headerBgColor="#162c47"
                  headerTextColor="white"
                >
                  <template slot="body-cell-rank" slot-scope="data">
                    <q-td :props="data.props">
                      <q-input
                        v-model="data.props.row.rank"
                        label="Rank"
                        @blur="saveSource(data.props.row)"
                      >
                      </q-input>
                    </q-td>
                  </template>
                  <template slot="body-cell-category" slot-scope="data">
                    <q-td :props="data.props">
                      <q-select
                        style="max-width: 400px"
                        use-input
                        fill-input
                        hide-selected
                        dense
                        color="accent"
                        @blur="
                          submitCategoryFromOutcome(
                            data.props.row,
                            data.props.row.categoryName
                          )
                        "
                        @popup-show="
                          filterCategoryOptionsByOutcome(data.props.row)
                        "
                        input-debounce="0"
                        label="Category Name"
                        v-model="data.props.row.categoryName"
                        :options="categoryOptions"
                        @filter="
                          (val, update, abort) =>
                            filterCategory(val, update, abort, data.props.row)
                        "
                        map-options
                        emit-value
                        option-label="name"
                      >
                        <template v-slot:no-option>
                          <q-item>
                            <q-item-section class="text-grey">
                              No results
                            </q-item-section>
                          </q-item>
                        </template>
                      </q-select>
                    </q-td>
                  </template>
                  <template slot="body-cell-actions" slot-scope="data">
                    <q-td :props="data.props">
                      <q-btn
                        class="float-right"
                        round
                        flat
                        color="red"
                        icon="mdi-delete"
                        @click="removeSource(data.props.row)"
                        size="md"
                      >
                      </q-btn>
                    </q-td>
                  </template>
                </data-table>
              </div>
            </div>
          </q-tab-panel>
          <!------CATEGORIES------------->
          <q-tab-panel name="categories">
            <div>
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div class="title q-my-none q-mx-none">Categories</div>

                    <div style="width: 200px">
                      <q-form ref="categoryForm">
                        <q-input
                          v-model="category"
                          label="Add Category"
                          color="accent"
                          dense
                          emit-value
                        >
                        </q-input>
                      </q-form>
                    </div>
                    <div>
                      <q-btn
                        color="primary"
                        @click="createCategory"
                        :disable="!category"
                      >
                        <q-icon name="mdi-plus-circle"> </q-icon>
                        <span
                          class="sustainability-font q-mx-sm"
                          style="font-size: 13px"
                        >
                          Add
                        </span>
                      </q-btn>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <q-input
                    class="searchbar float-right"
                    style="max-width: 70%"
                    filled
                    v-model="searchTextCategories"
                    debounce="200"
                    label="Search"
                    clearable
                    dense
                  >
                    <template #prepend>
                      <q-icon name="mdi-magnify"></q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <div class="row q-mt-lg">
                <div class="col-12">
                  <data-table
                    style="height: calc(100vh - 280px)"
                    flat
                    :filter="searchTextCategories"
                    :data="categoriesByOutcomeID"
                    :columns="columnsCategories"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                  >
                    <template slot="body-cell-rank" slot-scope="data">
                      <q-td :props="data.props">
                        <q-input
                          type="number"
                          v-model="data.props.row.rank"
                          @blur="saveCategory(data.props.row)"
                          dense
                          label="Rank"
                        >
                        </q-input>
                      </q-td>
                    </template>
                    <template slot="body-cell-categoryName" slot-scope="data">
                      <q-td :props="data.props">
                        <q-form
                          :ref="`categoryUpdateForm${data.props.row.id}`"
                          @submit.prevent="() => {}"
                        >
                          <q-input
                            style="max-width: 400px"
                            dense
                            hide-selected
                            color="accent"
                            :rules="[(v) => !!v || 'Name is Required']"
                            @blur="saveCategory(data.props.row)"
                            label="Category"
                            v-model="data.props.row.name"
                            :options="categoryOptions"
                            hide-bottom-space
                          >
                          </q-input>
                        </q-form>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          round
                          color="red"
                          flat
                          icon="mdi-delete"
                          @click="removeCategory(data.props.row)"
                          class="float-right"
                        >
                          <q-tooltip
                            content-class="bg-accent"
                            :offset="[10, 10]"
                          >
                            Remove Category
                          </q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </data-table>
                </div>
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="questions">
            <outcome-plan-question-tab></outcome-plan-question-tab>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
  import DataTable from "@/components/datatable/datatable.vue";
  import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";
  import OutcomePlanQuestionTab from "@/components/outcomePlanQuestionTab/outcomePlanQuestionTab.vue";
  import { mapGetters } from "vuex";
  export default {
    props: {
      newOutcome: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      DataTable,
      OutcomePlanQuestionTab,
    },
    mounted() {
      this.initOutcomeFormData();
    },
    computed: {
      ...mapGetters({
        goalsList: "goals/list",
        datatypesList: "datatypes/list",
        outcomesGoalsList: "goals/outcomesGoalsList",
        outcomesDatatypesList: "datatypes/outcomesDatatypesList",
        data: "outcomes/selectedOutcome",
        sectionsList: "sections/list",
        sourcesList: "sources/list",
        sourcesOutcomesList: "outcomes/sources/list",
        outcomesCategories: "outcomes/outcomesCategories",
      }),
      filteredSourcesList() {
        let filteredSources = this.sourcesSelectList;
        filteredSources = filteredSources.filter((e) => {
          if (
            this.sourcesOutcomesList.findIndex((os) => e.id == os.sourceId) < 0
          ) {
            return e;
          }
        });
        return filteredSources;
      },
      categoriesByOutcomeID() {
        return this.outcomesCategories.filter(
          (e) => e.outcomes_id == this.data.id
        );
      },
      columns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "rank",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "sourceName",
            label: "Source",
            align: "left",
            field: "sourceName",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "category",
            label: "Category",
            align: "left",
            field: "categoryName",
            style:
              "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      columnsCategories() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "categoryName",
            label: "Category",
            align: "left",
            field: "name",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "rank",
            style:
              "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "outcomesName",
            label: "Outcome",
            align: "left",
            field: "outcomesName",
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "left",
            field: "created_at",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
          },
        ];
      },
    },
    watch: {
      data: {
        deep: true,
        handler() {
          this.initOutcomeFormData();
        },
      },
    },
    data: () => ({
      statusOptions: ["Live", "Hide"],
      //tabs
      tab: "general",
      tabsList: [
        {
          name: "general",
          label: "Info",
          isError: false,
        },
        {
          name: "sources",
          label: "Sources",
          isError: false,
        },
        {
          name: "categories",
          label: "Categories",
          isError: false,
        },
        {
          name: "questions",
          label: "Questionnaire",
          isError: false,
        },
      ],

      outcomeGoalsTab: 0,
      outcomeDatatypeTab: 0,
      outcomeGoalFormData: {},
      outcomeFormData: {
        storyBoardWhatIs: "",
      },
      outcomeDatatypeFormData: {},

      //outcome image
      myCroppa: {},
      changeImage: false,

      //color picker dialog
      primaryColorDialog: false,
      secondaryColorDialog: false,
      tertiaryColorDialog: false,

      //source tab
      selectedSource: "",
      searchTextSources: "",
      categoryOptions: [],
      sourcesSelectList: [],

      //categories tab
      searchTextCategories: "",
      category: "",
    }),
    methods: {
      getWhiteOutcomeImage: getWhiteOutcomeImage,
      getOutcomeImage: getOutcomeImage,
      filterSource(val, update, abort) {
        update(() => {
          const source = val.toLowerCase();
          this.sourcesSelectList = this.sourcesList.filter(
            (s) => s.name.toLowerCase().indexOf(source) > -1
          );
        });
      },
      removeCategory(category) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedPayload = {
              ...category,
              deleted_at: Date.now(),
            };

            let result = await this.$store.dispatch(
              "outcomes/categories/save",
              removedPayload
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
              this.$store.dispatch("outcomes/loadAllOutcomesCategories");
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },
      stringToHexCode(value) {
        if (value) {
          let hexCode = value.replace("#", "");
          return "#" + hexCode;
        } else {
          return "";
        }
      },
      returnOutcomeImage(outcome) {
        return this.getOutcomeImage(outcome);
      },
      async addSource() {
        const isValid = await this.$refs.sourceForm.validate();
        if (isValid) {
          let sourcesOutcomePayload = {
            sources_id: this.selectedSource,
            outcomes_id: this.data.id,
          };

          let result = await this.$store.dispatch(
            "outcomes/sources/new",
            sourcesOutcomePayload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.selectedSource = "";
            this.$refs.outcomeForm.reset();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      filterCategoryOptionsByOutcome(value) {
        this.categoryOptions = this.outcomesCategories.filter(
          (cat) => cat.outcomes_id == value.outcomes_id
        );
      },
      filterCategory(val, update, abort, row) {
        update(() => {
          const category = val.toLowerCase();
          this.categoryOptions = this.outcomesCategories.filter(
            (cat) =>
              cat.name.toLowerCase().indexOf(category) > -1 &&
              cat.outcomes_id == row.outcomes_id
          );
        });
      },
      async submitCategoryFromOutcome(sourceOutcome, category) {
        if (category) {
          let sourceOutcomePayload = {
            ...sourceOutcome,
            categories_id: category.id,
          };
          delete sourceOutcomePayload["categoryName"];
          let result = await this.$store.dispatch(
            "sources/saveSourcesOutcomes",
            sourceOutcomePayload
          );
          this.$store.dispatch(
            "sources/loadSourcesByOutcomeID",
            sourceOutcomePayload.outcomes_id
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async saveSource(source) {
        let result = await this.$store.dispatch("outcomes/sources/save", source);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async removeSource(source) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedSource = {
              ...source,
              deleted_at: Date.now(),
            };
            let result = await this.$store.dispatch(
              "outcomes/sources/save",
              removedSource
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },
      initOutcomeFormData() {
        this.outcomeFormData = this.data;
      },
      closeDialog() {
        this.outcomeFormData = {};
        this.$router.push("/outcomes");
        this.$emit("closeDialog");
      },
      async createCategory() {
        const isValid = await this.$refs.categoryForm.validate();
        if (isValid) {
          let result = await this.$store.dispatch(
            "outcomes/newOutcomesCategory",
            {
              name: this.category,
              outcomes_id: this.data.id,
            }
          );

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.isAddingAction = false;
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
          this.category = "";
          await this.$refs.categoryForm.reset();
        }
      },
      async saveCategory(category) {
        const isValid = await this.$refs[
          `categoryUpdateForm${category.id}`
        ].validate();
        if (isValid) {
          let result = await this.$store.dispatch(
            "outcomes/saveOutcomesCategory",
            category
          );

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.isAddingAction = false;
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async saveOutcome() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          this.outcomeFormData.primaryColor = this.stringToHexCode(
            this.outcomeFormData.primaryColor
          );
          this.outcomeFormData.secondaryColor = this.stringToHexCode(
            this.outcomeFormData.secondaryColor
          );
          this.outcomeFormData.tertiaryColor = this.stringToHexCode(
            this.outcomeFormData.tertiaryColor
          );
          let payload = { ...this.outcomeFormData };
          //image uploading
          if (this.myCroppa && this.myCroppa.imageSet) {
            payload.imageUrl = {
              dataUrl: this.myCroppa.generateDataUrl(),
            };
          } else {
            delete payload.imageUrl;
          }
          let result = await this.$store.dispatch("outcomes/save", payload);
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.isAddingAction = false;
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
          this.closeDialog();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }

  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .sustainability-font {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
  }

  .tabTitle {
    font-weight: bold;
  }
</style>
